import { C } from "../lib/api";

// Mixed-game tournaments: tick the games in the order they rotate, one per level.
export const RotationPicker = ({ value = [], onChange, className = "" }) => {
  const toggle = (g) => onChange(value.includes(g) ? value.filter((x) => x !== g) : [...value, g]);
  return (
    <div className={`flex flex-col gap-1.5 ${className}`} data-testid="rotation-picker">
      <span className="text-[10px] uppercase tracking-[0.18em] opacity-70">Games in rotation — one per level, in the order ticked</span>
      <div className="flex flex-wrap gap-1.5">
        {Object.keys(C.GAME_RULES).map((g) => {
          const n = value.indexOf(g);
          return (
            <button type="button" key={g} onClick={() => toggle(g)} data-testid={`rotation-game-${g}`}
              className={`px-2.5 py-1 rounded-full text-[11px] border transition-colors ${n >= 0 ? "border-amber-300 bg-amber-300/15 text-amber-100" : "border-white/15 text-slate-400 hover:border-white/30"}`}>
              {n >= 0 && <span className="mr-1 font-mono">{n + 1}.</span>}{C.GAME_RULES[g].label}
            </button>
          );
        })}
      </div>
      {value.length < 2 && <span className="text-[10px] text-amber-300/80" data-testid="rotation-hint">Pick at least two games.</span>}
    </div>
  );
};
